import * as userRequest from "@/utils/userRequest";

const getUserInfo = async (token: string, onSuccess?: (data?: any) => any, handleError?: (err?: any) => any) => {
    try {
        const response = await userRequest.get("/user/info", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.data) {
            onSuccess && onSuccess(response?.data);
            return response.data;
        }
    } catch (error) {
        console.error("🚀 ~ getUserInfo ~ error:", error);
        if (handleError) {
            handleError(error);
        }
        throw error;
    }
};

export default getUserInfo;
